module.exports = __webpack_public_path__ + "img/xcx.7c345155.png";